export class PayPoint {
  public Id: number = -1;
  public UniqueId: string;
  public PayPointId: string = "";
  public Reference: string = "";
  public ActivationCode: string = "";
  public LicenceKey: string = "";
  public LastRegistered: Date;
  public Active: boolean = false;
  public Default: boolean = false;
  public Branch: number = -1;

  public static CreateFrom(p: PayPoint): PayPoint {
    var pp: PayPoint = new PayPoint();
    pp.Id = p.Id;
    pp.UniqueId = p.UniqueId;
    pp.PayPointId = p.PayPointId;
    pp.Reference = p.Reference;
    pp.ActivationCode = p.ActivationCode;
    pp.LicenceKey = p.LicenceKey;
    pp.LastRegistered = p.LastRegistered;
    pp.Active = p.Active;
    pp.Default = p.Default;
    pp.Branch = p.Branch;
    return pp;
  }
}
